import { render } from "./AdditionalConfigSnippet.vue?vue&type=template&id=1d7f5ba0"
import script from "./AdditionalConfigSnippet.vue?vue&type=script&lang=js"
export * from "./AdditionalConfigSnippet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__